// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"55f338f1","229":"460c05db","247":"81f7f48d","551":"dc7ff3e2","627":"c1588c43","653":"ebee4bd7","834":"349f5363","842":"8cda7f00","867":"eac94abd","923":"7c7466a7","938":"17f18ff3"}[chunkId] + ".chunk.js";
};